import { isAdminUser } from "../../services/authService";
import { getUserInfo } from "../../services/localStorage";

function strip(v) {
  return v == null ? "" : String(v).trim();
}

function hasExplicitAdminAgentFilter(filters = {}) {
  if (!filters || typeof filters !== "object") return false;
  if (strip(filters.agent_filter_id)) return true;
  if (strip(filters.agent_email)) return true;
  if (strip(filters.selected_agent_id)) return true;
  return false;
}

/**
 * Resolves list scope for POST /getLDSOrdersByAgentId.
 * Admin default: all agents (scope=all). Regular agent: own orders only (scope=mine).
 */
export function resolveLdsOrdersListRequestScope(filters = {}) {
  const userInfo = getUserInfo();
  const viewerAgentId = userInfo?.id != null ? String(userInfo.id) : null;
  const isAdmin = isAdminUser();

  if (!isAdmin) {
    return {
      scope: "mine",
      agentId: viewerAgentId,
      includeAllAgents: false,
    };
  }

  if (hasExplicitAdminAgentFilter(filters)) {
    return {
      scope: "filtered",
      agentId: viewerAgentId,
      includeAllAgents: false,
    };
  }

  return {
    scope: "all",
    agentId: null,
    includeAllAgents: true,
  };
}
